import React, { useState,useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardMedia from "@material-ui/core/CardMedia";
import guiaPago from "../../img/guia-ayuda-pago.png";
import pagoLinea from "../../img/pago-linea.png";
import IconButton from "@material-ui/core/IconButton";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import ModalError from "../modal-error/modal-error.cmpt";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import {downloadPDF,mensajesModal} from "../utils";
import { servicios } from "../../properties";
import { makeStyles } from "@material-ui/core/styles";
import * as action from "../pagoDeducibleAuto-actions";
const borderBox = "border-box";
const borderCard = "1px solid #DBE4F0";
const boxCard = "0px 4px 16px rgba(0, 63, 138, 0.22)";

const useStyles = makeStyles((theme) => ({
    cardReferenciaPago: {
        background: "#FFFFFF",
        border: borderCard,
        boxSizing: borderBox,
        boxShadow: boxCard,
        borderRadius: "5px",
        width: "100%",
    },
    iconButton: {
        width: "24px",
        height: "24px",
        color: "#FF6B0B",
    },
}));

const descargaRef = (refBase64,setDatosModal,setOpenModalNotificacion) =>{
    if(refBase64 && refBase64 !== ""){
        downloadPDF(refBase64, "ReferenciasBancarias.pdf");
    }else {
        setDatosModal({...mensajesModal.modalErrorReferencia});
        setOpenModalNotificacion(true);
    }
};

const envioExitosoCorreo = (dispatch,setDatosModal,setOpenModalNotificacion) => {
    dispatch(action.onLoading(false));
    setDatosModal({
        msjTitle: mensajesModal.modalEnvioCorreoExito.msjTitle,
        msjBody: mensajesModal.modalEnvioCorreoExito.msjBody,
        withButtons: {...mensajesModal.modalEnvioCorreoExito.withButtons}
    });
    setOpenModalNotificacion(true);
}

const errorCorreoGuiaRef = (error,dispatch,setDatosModal,setOpenModalNotificacion) => {
    dispatch(action.onLoading(false));
    setDatosModal({
        msjTitle: mensajesModal.modalErrorCorreoGuiaRef.msjTitle,
        msjBody: mensajesModal.modalErrorCorreoGuiaRef.msjBody,
        withButtons: {...mensajesModal.modalErrorCorreoGuiaRef.withButtons}
    });
    dispatch(action.onLoading(false));
    setOpenModalNotificacion(true);
    console.error(error);
}

const PagoVentanilla = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const dataSeguimiento = useSelector(
        (state) => state.pagoDeducibleAutos.pagoDeducibleAutos
    );
    const global = useSelector((state) => state.global);
    const [datosModal, setDatosModal] = useState({
        msjTitle: "",
        msjBody: "",
        withButtons: {
            actionButtons: true,
            msjButton1: "Aceptar",
            msjButton2: "Cancelar",
        },
        tipo: "",
    });
    const [datosModalCorreo, setDatosModalCorreo] = useState({
        msjTitle: "",
        msjBody: "",
        withButtons: {
            actionButtons: true,
            msjButton1: "Aceptar",
            msjButton2: "Cancelar",
        },
        tipo: "",
    });
    const [modalEnvioCorreo,setOpenModalEnvioCorreo] = useState(false);
    const [modalNotificacion,setOpenModalNotificacion] = useState(false);
    const [datosReferenciaBancaria, setDatosReferenciaBancaria] = useState({
        nombreDocumento: "",
        urlVisualizacion: "",
		base64: ""
    });
    
    useEffect(() => {
        setDatosReferenciaBancaria({
            nombreDocumento: props.datosReferenciaBancaria.nombreDocumento,
            urlVisualizacion: props.datosReferenciaBancaria.urlVisualizacion,
			base64: props.datosReferenciaBancaria.base64
        });
    }, [props]);

    const openModalEnvioCorreo = (e, msjTitle, msjBody, tipo) => {
        setDatosModalCorreo({...datosModalCorreo,
            msjTitle,
            msjBody,
            tipo,
        });
        setOpenModalEnvioCorreo(true);
    };
    const handleEnvioCorreo = (e) => {
        if (e === "buttonIcon" || e === "button2") {
            setOpenModalEnvioCorreo(false);
        } else {
            setOpenModalEnvioCorreo(false);
            if (datosModalCorreo.tipo === "guia") {
                handleCorreoGuia();
            } else if (datosModalCorreo.tipo === "referencia") {
                handleCorreoReferencia();
            }
        }
    };

    const handleCorreoGuia = () => {
        dispatch(action.onLoading(true));
        dispatch(action.postCorreoGuiaPago(global.tid))
            .then((response) => {
                envioExitosoCorreo(dispatch,setDatosModal,setOpenModalNotificacion);
            })
            .catch((error) => {
                errorCorreoGuiaRef(error,dispatch,setDatosModal,setOpenModalNotificacion);
            });
    };

    const handleCloseNotificacion = (event) => {
        if (event === "buttonIcon") {
            setOpenModalNotificacion(false);
        }
        setDatosModal({
            msjTitle: "",
            msjBody: "",
            withButton: {
                actionButton: false,
                msjButton1: "",
            },
            tipo: "",
        });
    };
    const handleCorreoReferencia = () => {
        dispatch(action.onLoading(true));
        dispatch(
        action.postCorreoReferenciaBancaria(global.tid, {
            codSiniestro: dataSeguimiento.codSiniestroPadre,
        })
        )
        .then((response) => {
            envioExitosoCorreo(dispatch,setDatosModal,setOpenModalNotificacion);
        })
        .catch((error) => {
            errorCorreoGuiaRef(error,dispatch,setDatosModal,setOpenModalNotificacion);
        });
    };
    const modalCorreoGuia = (
        <ModalError
            iconButton={true}
            openModal={modalEnvioCorreo}
            msjTitle={datosModalCorreo.msjTitle}
            msjBody={`Se enviará un correo con la ${datosModalCorreo.msjBody}`}
            withButtons={{ ...datosModalCorreo.withButtons }}
            handleClose={(e) => handleEnvioCorreo(e)}/>
    );
    const modalNotificacionCorreo = (
        <ModalError
            iconButton={true}
            openModal={modalNotificacion}
            msjTitle={datosModal.msjTitle}
            msjBody={datosModal.msjBody}
            handleClose={(e) => handleCloseNotificacion(e)}/>
    );
    return(   
    <div>
        <p className="pVentanilla">Referencias bancarias</p>
        <label className="pSolicitudVentanilla">
        Descarga e imprime la referencia para realizar el pago en la institución bancaria de tu preferencia.
        </label>
        <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Card className={classes.cardReferenciaPago}>
                    <CardMedia className={classes.imageReferenciaPago} component="img" alt="Contemplative Reptile"
                        height="140"
                        image={pagoLinea}/>
                    <CardActions>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={12} lg={8} style={{ alignSelf: "center" }}>
                                <p className="pReferenciaPago">
                                    Referencia Bancaria
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={4}>
                                <IconButton onClick={(e) => openModalEnvioCorreo(e,"Envio correo Referencia Bancaria","Referencia Bancaria","referencia")}>
                                    <MailOutlineIcon
                                        className={classes.iconButton}
                                    ></MailOutlineIcon>
                                </IconButton>
                                 <a onClick={() => descargaRef(datosReferenciaBancaria.base64,setDatosModal,setOpenModalNotificacion)}>
                                    <IconButton>
                                        <GetAppOutlinedIcon
                                            className={classes.iconButton}
                                        ></GetAppOutlinedIcon>
                                    </IconButton>
                                </a>
                            </Grid>
                        </Grid>
                    </CardActions>
                </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Card className={classes.cardReferenciaPago}>
                    <CardMedia className={classes.imageReferenciaPago} component="img"
                        alt="Contemplative Reptile"
                        height="140"
                        image={guiaPago}/>
                    <CardActions>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={12} lg={8} style={{ alignSelf: "center" }}>
                                <p className="pReferenciaPago">
                                    Guía de ayuda para pago
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={4}>
                                <IconButton onClick={(e) => openModalEnvioCorreo(e,"Envio correo Guia de ayuda para pago","Guia de ayuda para pago","guia")}>
                                    <MailOutlineIcon
                                        className={classes.iconButton}
                                    ></MailOutlineIcon>
                                </IconButton>
                                <a href={`${servicios.pagoDeducibleAutos.urlBaseStorage}/PagoDeducibleAuto/GuiaPagoDeducible.pdf`} target="_blank">
                                    <IconButton>
                                        <GetAppOutlinedIcon
                                            className={classes.iconButton}
                                        ></GetAppOutlinedIcon>
                                    </IconButton>
                                </a>
                            </Grid>
                        </Grid>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
        {modalCorreoGuia}
        {modalNotificacionCorreo}
    </div>
    );
};
export default PagoVentanilla;


// WEBPACK FOOTER //
// ./src/pago-deducible-auto/pago/pagoVentanilla.cmpt.js